export enum PlacementTypeEnum {
    Test = 10,
    Demo = 11,
    Present = 12,
    JobInterview = 13
}